export default "<!doctype html> <html> <head> </head> <body> </body> </html> ";